@<template>
  <div>
    <training @flashData = "flashData"></training>
    <div class="content">
      <div class="content-play">
        <Specification ref="tree"></Specification>
      </div>
    </div>
  </div>
</template>
<script>
  import Training from "./components/training";
  import Specification from "./components/specification";
  export default {
    components: {Specification,Training},
    name: "study",
    methods: {
      async flashData(){
        this.$refs.tree.flashData();
      }
    }
  }
</script>

<style scoped>
  .content{
    width: 100%;
    height: 575px;
  }
  .content-play{
    width: 1050px;
    height: 575px;
    margin: 0 auto;
  }
  .footer{
    width: 100%;
    height: 30px;
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/pages/study/study.vue